import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'


class _NRTCardStack extends Component {

    animationDuration = 750

    state = {
        goingForward: false,
        goingBack: false,

    }




    componentWillReceiveProps(nextProps) {


        const {activeCard} = this.props
        const {activeCard: nextActiveCard} = nextProps


        if (activeCard !== nextActiveCard)
            this.handleCardChange(activeCard, nextActiveCard)

    }


    handleCardChange(activeCard, nextActiveCard) {
        if (activeCard < nextActiveCard) {
            this.setState({
                goingForward: true,
                goingBack: false,
            })

        } else if (activeCard > nextActiveCard) {
            this.setState({
                goingForward: false,
                goingBack: true,
            })
        }

        setTimeout(() => {
            this.setState({
                goingForward: false,
                goingBack: false,
            })
        }, this.animationDuration - 50)

    }


    render() {


        const {
            goingForward,
            goingBack
        } = this.state

        const {activeCard} = this.props

        const card = this.props.children[activeCard] || null
        const prevCard = this.props.children[activeCard - 1] || null
        const nextCard = this.props.children[activeCard + 1] || null

        return (
            <div className='nrt-cardstack'
                 ref={(container) => this.container = container}>


                {
                    goingForward === false &&
                    goingBack === false &&
                    card
                }

                {
                    goingBack &&
                    <div style={{
                        width: '200%',
                        display: 'flex',
                        animationName: 'goingBack',
                        animationDuration: this.animationDuration + 'ms',
                        animationTimingFunction: 'ease'

                    }}>

                        <div style={{width: '100%'}}>
                            {card}
                        </div>
                        <div style={{width: '100%'}}>
                            {nextCard}

                        </div>
                    </div>
                }

                {
                    goingForward &&
                    <div style={{
                        width: '200%',
                        display: 'flex',
                        animationName: 'goingForward',
                        animationDuration: this.animationDuration + 'ms',
                        animationTimingFunction: 'ease'
                    }}>

                        <div style={{width: '100%'}}>
                            {prevCard}
                        </div>
                        <div style={{width: '100%'}}>
                            {card}
                        </div>
                    </div>
                }


            </div>
        )
    }
}


const NRTCardStack = _NRTCardStack

NRTCardStack.propTypes = {
    activeCard: PropTypes.number.isRequired
}

NRTCardStack.defaultProps = {}


export default NRTCardStack



// WEBPACK FOOTER //
// ./src/components/_common/CardStack/index.js